/**
 * L'impegno previsto di un consulente, con la sua unità.
 *
 * Il campo si chiamava "Giornate/ore previste" e in archivio erano sempre ORE:
 * scrivendo 3 pensando a tre giornate, la lettera d'incarico le divideva per 8
 * e usciva "0,38 giornate" (incarico Delucchi, 28/10/2026). Qui l'unità si
 * dichiara, la conversione avviene in un posto solo e il numero torna a video
 * come è stato scritto.
 *
 * Verso l'esterno restano ore, perché è su quelle che si misura lo sforamento.
 */
import { ORE_PER_GIORNO, impegnoDaOre } from './impegno';

export default function CampoImpegno({ ore, unita = 'ora', onChange, className = 'input' }) {
  const u = unita === 'giorno' ? 'giorno' : 'ora';
  const mostrato = impegnoDaOre(ore, u);

  const cambiaNumero = (v) => {
    const n = Number(String(v).replace(',', '.'));
    const quantita = v === '' || Number.isNaN(n) ? '' : n;
    onChange({ ore: quantita === '' ? '' : quantita * (u === 'giorno' ? ORE_PER_GIORNO : 1), unita: u });
  };

  // Cambiando unità si tiene il NUMERO, non le ore: chi passa a "giornate"
  // dopo aver scritto 3 intende tre giornate, non tre ottavi.
  const cambiaUnita = (nuova) => {
    const n = Number(mostrato);
    onChange({ ore: mostrato === '' ? '' : n * (nuova === 'giorno' ? ORE_PER_GIORNO : 1), unita: nuova });
  };

  return (
    <div className="flex gap-2">
      <input className={`${className} flex-1`} type="number" step="0.5" min="0"
             value={mostrato} onChange={e => cambiaNumero(e.target.value)} />
      <select className={`${className} w-32 shrink-0`} value={u} onChange={e => cambiaUnita(e.target.value)}>
        <option value="giorno">giornate</option>
        <option value="ora">ore</option>
      </select>
    </div>
  );
}
